import styled from "@emotion/styled";

const Title = styled.div`
  padding: 45px 0;
`;

const Styled = { Title };
export default Styled;
